// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nJzQ","left":"styles_left__qMkFJ","desktopActions":"styles_desktopActions__1J5xS","title":"styles_title__2-KPv"};